import axios from 'services/axios-interceptors';
import { API_PATH } from 'store/service';

export const ismsClassificationServices = {
  getIsmsClassifications() {
    return axios.get(API_PATH + '/project/ismsClassification/all');
  }
};
